export const MORNING_EMAIL_LIST_ID = 1271;
export const AFTERNOON_EMAIL_LIST_ID = 1272;
export const EVENING_EMAIL_LIST_ID = 1273;
export const WEEKEND_EMAIL_LIST_ID = 1274;
export const PRODUCT_EMAIL_LIST_ID = 1249;
export const PROMOTIONS_EMAIL_LIST_ID = 1250;
